<template>
<div class="tab-pane " :class="{ 'active show': $parent.isActive(String(tierid)) }" :id="`panel-${tierid}`" role="tabpanel" :aria-labelledby="`panel-${tierid}-tab`" >
<!-- Mobile Button -->
<!-- Collapse Button -->
<button 
v-b-toggle="collapseid" 
class="btn btn--select" 
@click.prevent="setParentActive"
@keydown="openOnKeyDown"
:class="{ active: $parent.isActive(String(tierid)) }"

>

    <div class="nav-link__wrapper">
        <div class="nav-link__content">
            <div class="heading">{{displayname}}</div>
            <div v-if="discountPrice !== null" class="tier-price">
                <span class="full-price strikethrough">${{price}}/YR</span>
                <span class="discounted-price">${{discountPrice}}/YR</span>
            </div>
            <div v-else>
                <span class="full-price">${{price}}/YR</span>
            </div>
        </div>
    </div>
</button>

<!-- End Mobile Button -->
<!-- Collapse Content -->
<div class="collapse-wrapper">
    <b-collapse :id="collapseid" v-model="visible" @hidden="$parent.onHidden">
        <slot></slot>
    </b-collapse>
</div>
<!-- End Collapse Content-->

</div>              
</template>

<script>
import KeyCodes from "@/utils/key-codes"
export default {
    name: 'selector-panel',
    props: {
        tierid: '',
        displayname: '',
        price: '',
        discountPrice: '',
        tiercode: ''
    },
    data() {
        return {
            visible: false
        }
    },
    computed: {
        collapseid() {
            return 'collapse-panel-' + this.tierid
        }
    },
    methods: {
        setParentActive() {
            this.$parent.setActive(String(this.tierid));
        },
        openOnKeyDown() {
            // Down arrow to expand
            if (event.keyCode === KeyCodes.DOWN || event.key === "ArrowDown") {
                event.preventDefault();
                this.visible = true;
            }

            if (event.keyCode === KeyCodes.ESCAPE || event.key === "Escape") {
                event.preventDefault();
                this.visible = false;
            }

        }
    },
    mounted() {
        const tabbables = this.$el.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
        let lastTabbable = tabbables[tabbables.length - 1];
        if (window.getComputedStyle(lastTabbable).display === 'none') {
            lastTabbable = tabbables[tabbables.length - 2];
        }
        lastTabbable.addEventListener('keydown', (evt) => {
            this.$parent.nextTab();
        });
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/member-tier-selector-panel.vue